import React, {Component} from 'react';
import FilterHasResults from '../parts/FilterHasResults';
import Axios from 'axios';
import AppHeader from '../parts/AppHeader';
import APIENDPOINT from '../ApiEndpoint';

class FilterResultScreen extends Component {
    constructor(props){
        super(props);
        this.state = {
            mcards: [],
            types: [],
            typesfull: []
        }
    }
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);

        data.forEach(type => {
            this.setState({types : [...this.state.types, type.type_name] });
            this.setState({typesfull : [...this.state.typesfull, type] });
        });
        

        Axios.get(`${APIENDPOINT}/mcard`)
        .then(response => {
            const {data} = response;

            let mcards = Object.values(data);

            function parseLocalStorageArray(localStorageItemName){
                return localStorage.getItem(localStorageItemName).split("&").slice(0, -1);
            }

            this.state.types.forEach(type => {
                const typeParsed = type.replace(/-/g, "").replace(/ /g, "-").toLowerCase();
                if(localStorage.getItem(typeParsed)){
                    const typeOptions = parseLocalStorageArray(typeParsed);
                    typeOptions.forEach(typeOption => {
                        mcards = mcards.filter(mcard => {

                              return mcard.options[type] && Object.values(mcard.options[type]).includes(typeOption);
                        });
                    });
                }
            });
            
            this.setState({mcards});
        })
        .catch(err => {
            console.log(err);
        })
    }
    render(){

        let filtersOptionsValues = [];
        const localStorageValues = ["breinwaarde", "duur-les", "didactisch-principe", "duur-voorbereiding", "aantal-studenten", "kennis-of-vaardigheidsvak"];
        //voor elke waarde...
        localStorageValues.forEach(function(localStorageValue){
            if(localStorage.getItem(localStorageValue) !== null){
                localStorage.getItem(localStorageValue).split("&").slice(0, -1).forEach(() => {
                    filtersOptionsValues.push(localStorageValue);
                }); 
            }
        })
        

        console.log(filtersOptionsValues);



        return(
            <div>
                <AppHeader titleText='Werkvormen' titleTextLink='/resultaten' rightButton='' leftButton='Back' backLink='/' />
                <FilterHasResults amount={this.state.mcards.length} mcards={this.state.mcards} />
            </div>
        )
    }
}

export default FilterResultScreen;